var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1580_2260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#886DF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1580_2260)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1580_2260)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.5C19.5355 15.5 20.375 14.6605 20.375 13.625C20.375 12.5895 19.5355 11.75 18.5 11.75C17.4645 11.75 16.625 12.5895 16.625 13.625C16.625 14.6605 17.4645 15.5 18.5 15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.625C14.5355 13.625 15.375 12.7855 15.375 11.75C15.375 10.7145 14.5355 9.875 13.5 9.875C12.4645 9.875 11.625 10.7145 11.625 11.75C11.625 12.7855 12.4645 13.625 13.5 13.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 17.375C15.375 16.6844 15.9294 16.125 16.625 16.125H20.375C21.0656 16.125 21.625 16.6781 21.625 17.375V19.7062C21.625 21.5981 15.375 21.5981 15.375 19.7062V17.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 15.5C16.6252 15.3358 16.5931 15.1731 16.5304 15.0214C16.4676 14.8696 16.3756 14.7317 16.2594 14.6156C16.1433 14.4994 16.0054 14.4074 15.8536 14.3446C15.7019 14.2819 15.5392 14.2498 15.375 14.25H11.625C10.9294 14.25 10.375 14.8106 10.375 15.5019V17.8931C10.375 19.0938 12.9088 19.4669 14.75 19.1331V17.3788C14.7496 17.1324 14.7977 16.8884 14.8916 16.6606C14.9856 16.4328 15.1234 16.2258 15.2974 16.0513C15.4713 15.8769 15.6779 15.7384 15.9054 15.6438C16.1329 15.5492 16.3768 15.5003 16.6231 15.5H16.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1580_2260",
    x: 0,
    y: 0.5,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1580_2260"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.284122 0 0 0 0 0.00449997 0 0 0 0 0.8955 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1580_2260"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145413 0 0 0 0 0.0684 0 0 0 0 0.3116 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1580_2260",
    result: "effect2_dropShadow_1580_2260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1580_2260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1580_2260",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1580_2260",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingUserIcon);
export default __webpack_public_path__ + "static/media/savingUserIcon.a9f109f0afa1861dd9fc6540ede6725e.svg";
export { ForwardRef as ReactComponent };